import { useMemo } from 'react';

import getResumeInitialValues from '@glass/shared/modules/resumes/getResumeInitialValues';

const useResumeInitialValues = ({ initialValues, resume, activeSection }) =>
  useMemo(
    () =>
      initialValues ? getResumeInitialValues({ activeSection }, initialValues, resume) : resume,
    [activeSection, resume, initialValues],
  );

export default useResumeInitialValues;
